/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component, lazy, Suspense } from 'react';
import { withRouter } from 'react-router-dom';
import axios from "axios";
import { CircularProgress } from '@mineral/core';
import connect from '../../../../utils/connect';
import { setBreadCrumbs } from '../../../breadcrumbs/actions';
import Resource from './Resource';
const ListDashboardDesignerComponent = lazy(() => import('@uim/listdesigner'));
//List Dashboard Designer
export const title = Resource.get('List Viewer'); //List Viewer

class ListDashboardDesignerWrapper extends Component {
  state = {
    sid: null,
  };

  componentWillMount = () => {
    this.setState({ sid: this.props.sid });
  };

  componentDidMount() {
    this.props.setBreadCrumbs([
      {
        name: 'Dashboards',
        link: ''
      },
      {
        name: title,
        link: '/settings/listviewer',
      },
    ]);
  }

  render() {
    let view = (
      <div
        className="spinner"
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress style={{ color: '#3272D9' }} />
      </div>
    );

    if (this.state.sid) {
      let do_heartbeat = window.OPERATOR_CONSOLE.do_heartbeat;

      if (do_heartbeat !== 'true' && do_heartbeat !== 'false') {
        do_heartbeat = false;
      }

      view = (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 700,
          }}
        >
          <Suspense fallback={<div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
           <CircularProgress style={{ color: "#3272D9" }} />
          </div>}>
            <ListDashboardDesignerComponent
              axiosInterceptors={axios.default.interceptors}
              sid={this.state.sid}
              viewType='viewer'
              copyURL={this.props.copyURL}
            />
          </Suspense>
        </div>
      );
    }

    return view;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setBreadCrumbs: (items) => dispatch(setBreadCrumbs(items)),
  };
};

const mapStateToProps = (state) => {
  return {
    sid: state.sid,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ListDashboardDesignerWrapper));
